var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-nav-bar',{attrs:{"left-text":"返回","left-arrow":""},on:{"click-left":_vm.onClickLeft}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service_layout_style"},[_c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":require("../assets/img/客服.jpg"),"alt":""}})])
}]

export { render, staticRenderFns }